// @flow
import Security from '../libs/security/Security';
import { captureException, captureMessage } from '@sentry/browser';

export const setUpTherapistPublicKey = async (therapistUid: string) => {
  // const therapistPublicKey = await Security.lookupPublicKeys(therapistUid);
  // // console.log('therapistPublicKey: ', therapistPublicKey);
  // await Security.setUserPublicKey(therapistPublicKey);
  try {
    // Setando primeiro a patientUid pq dps se der merda ele ainda vai tentar pegar a publicKey de novo
    Security.setUids(null, therapistUid);

    // const therapistPublicKey = await Security.findUsers(therapistUid);
    const therapistPublicKey = await Security.findUsers(therapistUid);

    // console.log('therapistPublicKey: ', therapistPublicKey);
    await Security.setUserPublicKey(therapistPublicKey);
  } catch (error) {
    // console.log('Error no setUpTherapistPublicKey para terapeuta: ', therapistUid);
    captureException(error);
    // throw error;
  }
};

export const getTherapistPublicKey = async () => {
  const publicKey = await Security.getUserPublicKey();
  return publicKey;
};

export const getPatientPublicKey = () => {
  const publicKey = Security.getRecipientPublicKey();
  // console.log('A CHAVE DO PACIENTE: ', publicKey)
  return publicKey;
};

export const setUpPatientPublicKey = async (patientUid: string) => {
  try {
    // Setando primeiro a patientUid pq dps se der merda ele ainda vai tentar pegar a publicKey de novo
    Security.setUids(patientUid, null);

    const patientPublicKey = await Security.findUsers(patientUid);
    // console.log('patientPublicKey: ', patientPublicKey)
    await Security.setRecipientPublicKey(patientPublicKey);
  } catch (error) {
    // console.log('Error no setUpPatientPublicKey para patientUid: ', patientUid);
    captureException(error);
    // throw error;
  }
};

export const setUpSecurity = async (therapistUid: string) => {
  if (therapistUid) {
    // console.log('TEM THERAPISTID: ', therapistUid);
    try {
      await Security.initialize(therapistUid);
      await Security.setUids(null, therapistUid);
      // console.log('Initializou e vai registrar');
      await Security.restorePrivateKeyOrRegister(therapistUid);
      // // console.log('Vai dar backupPrivateKey');
      // await Security.backupUserPrivateKey(userUID);
      // console.log('Vamos pegar as chaves do terapeuta');
      await setUpTherapistPublicKey(therapistUid);
    } catch (error) {
      // console.log('NAO TEM THERAPISTID')
      captureException(error);
      throw error;
    }
  } else {
    // console.log('NAO TEM THERAPISTID');
    captureMessage('Nao tem therapistUid no setUpSecurity');
    throw new Error();
  }
};

// We need a method to check because if publicKey is either null or {} it will cause errors
// Invalid format of data Error when decrypting from {} publick key encryption
// Foundation Error Recipient defined with id is not found within message info during data decryption
// when decrypting from null public key encryption
const isPublicKeyEmpty = (publicKey: Object) => {
  return !publicKey || Object.keys(publicKey).length === 0;
};

// Sets again the publicKey of either the therapist or patient if they had not been set
const setUpMissingPublicKey = async (userType: string) => {
  switch (userType) {
    case 'therapist':
      const therapistUid = Security.getTherapistUid();
      if (therapistUid) {
        await setUpTherapistPublicKey(therapistUid);
      }
      return;
    case 'patient':
      const userUid = Security.getUserUid();
      if (userUid) {
        await setUpPatientPublicKey(userUid);
      }
      return;
    default:
      return;
  }
};

const retrievePublicKey = (typeUser: string) => {
  return {
    patient: Security.getRecipientPublicKey(),
    therapist: Security.getUserPublicKey()
  }[typeUser];
};

const checkPublicKeyIsEmptyAndSetIfNeeded = async (userType: string) => {
  let publicKey = retrievePublicKey(userType);
  if (isPublicKeyEmpty(publicKey)) {
    // console.log('vai setar a chave novamente no getUserOrTherapistPublicKey')
    await setUpMissingPublicKey(userType);

    // After setting it we retrieve the key again
    // console.log('vai pegar a chave de novo')
    publicKey = retrievePublicKey(userType);
    // console.log('publicKey retrieved: ', publicKey)
  }
  return publicKey;
};

/**
  Returns the publicKey of the user or therapist depending on encryptedByPatient
  It first checks whether the publicKey is not null.
  If it is it sets the public key again and returns it
 */
const getUserOrTherapistPublicKey = async (userType: string) => {
  let publicKey = await checkPublicKeyIsEmptyAndSetIfNeeded(userType);

  // We try twice to get the publicKey not empty
  if (isPublicKeyEmpty(publicKey)) {
    publicKey = await checkPublicKeyIsEmptyAndSetIfNeeded(userType);
  }

  return publicKey;
};

export const encryptText = async (textToEncrypt: string) => {
  // If recipientPublicKey is null or undefined we cant encrypt otherwise there will be an error
  // Thus we try to set it again to encryptText afterwards
  // console.log('vai pegar a key no encryptText')
  const recipientPublicKey = await getUserOrTherapistPublicKey('patient');
  // console.log('recipientPublicKey: ', recipientPublicKey);
  // const recipientPublicKey = await Security.getRecipientPublicKey();

  // SE TIVER PUBLIC KEY DO PACIENTE ENTAO MANDA A MENSAGEM ENCRIPTADA
  // SE NAO TIVER NAO ENCRIPTA E TEM QUE SINALIZAR ISSO PARA O METODO QUE CHAMA PODER COLOCAR A TAG
  let encryptedText = textToEncrypt;
  let wasAbleToEncrypt = false;
  if (!isPublicKeyEmpty(recipientPublicKey)) {
    // console.log('TEM CHAVE, VAI ENCRIPTAR')
    try {
      encryptedText = await Security.encryptText(textToEncrypt, recipientPublicKey);
      wasAbleToEncrypt = true;
    } catch (error) {
      // console.log('ERROR NO encryptText Controller: ', error);
      captureException(error);
    }
  } else {
    // console.log('NAO TEM CHAVE, NAO ENCRIPTOU')
    captureMessage('User não tem chave ainda e não encriptou');
  }
  // console.log('encyptedText: ', encryptedText);
  return [encryptedText, wasAbleToEncrypt];
};

export const decryptText = async (text: string, encryptedByPatient: boolean) => {
  // const publicKey = encryptedByPatient ? Security.getRecipientPublicKey() : Security.getUserPublicKey();
  // // console.log('senderPublicKey: ', publicKey);
  // let decryptedText = null;
  // try {
  //   decryptedText = await Security.decryptText(text, publicKey);
  // } catch (error) {
  //   // console.log('ERROR NO decryptText Controller: ', error);
  //   captureException(error);
  // }
  // return decryptedText;

  if (text) {
    const userKeyToRetrieve = encryptedByPatient ? 'patient' : 'therapist';
    // console.log('vai pegar a key no decryptText para: ', userKeyToRetrieve)
    const publicKey = await getUserOrTherapistPublicKey(userKeyToRetrieve);
    let decryptedText = null;

    // NAO SEI SE TENHO QUE CHECAR SE O publicKey EH EMPTY OU NAO PARA DECRIPTAR
    try {
      decryptedText = await Security.decryptText(text, publicKey);
      // console.log('decryptedText: ', decryptedText);
    } catch (error) {
      // console.log('ERROR NO decryptText Controller: ', error);
      captureException(error);
    }
    return decryptedText;
  } else {
    return '';
  }
};
